import { render } from "./BriefcaseHorizontal.vue?vue&type=template&id=7dd995ea&scoped=true"
import script from "./BriefcaseHorizontal.vue?vue&type=script&lang=js"
export * from "./BriefcaseHorizontal.vue?vue&type=script&lang=js"

import "./BriefcaseHorizontal.vue?vue&type=style&index=0&id=7dd995ea&lang=scss"
import "./BriefcaseHorizontal.vue?vue&type=style&index=1&id=7dd995ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd995ea"]])

export default __exports__